import { proxy, ref } from 'valtio';

export type AssetUploadType = 'image' | 'video' | 'audio';

export interface AssetUploadTask {
  id: string;
  file: File;
  type: AssetUploadType;
  progress: number;
  status: 'uploading' | 'failed' | 'success';
  error?: string;
  abortController: AbortController;
  nodeId?: string;
}

/**
 * 素材上传任务 store
 */
export const assetUploadStore = proxy({
  uploadTasks: [] as AssetUploadTask[],
});

export function addUploadTask(task: AssetUploadTask) {
  // 使用 ref 避免 valtio 代理原生 File 和 AbortController 对象，防止 Illegal invocation
  const taskWithRefs = {
    ...task,
    file: ref(task.file),
    abortController: ref(task.abortController),
  };
  assetUploadStore.uploadTasks.push(taskWithRefs);
}

export function updateUploadProgress(id: string, progress: number) {
  const task = assetUploadStore.uploadTasks.find((t) => t.id === id);
  if (task) {
    task.progress = progress;
  }
}

export function setUploadStatus(id: string, status: AssetUploadTask['status'], error?: string) {
  const task = assetUploadStore.uploadTasks.find((t) => t.id === id);
  if (task) {
    task.status = status;
    if (error) task.error = error;
  }
}

export function removeUploadTask(id: string) {
  const idx = assetUploadStore.uploadTasks.findIndex((t) => t.id === id);
  if (idx !== -1) {
    assetUploadStore.uploadTasks.splice(idx, 1);
  }
}

export function cancelUploadTask(id: string) {
  const idx = assetUploadStore.uploadTasks.findIndex((t) => t.id === id);
  if (idx !== -1) {
    const task = assetUploadStore.uploadTasks[idx];
    if (task.status === 'uploading') {
      task.abortController.abort();
    }
    assetUploadStore.uploadTasks.splice(idx, 1);
  }
}
